(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tot-school-print-style"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const link=event.target.closest('[data-print-style-link]');
  if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const destination=new URL(link.href);
  destination.search=window.location.search;
  destination.searchParams.delete('page');
  window.location.assign(destination.href);
},true);
document.addEventListener('keydown',function(event){
  if(event.key!=='Escape')return;
  const details=event.target.closest('.tot-print-style');
  if(details){details.open=false;details.querySelector('summary').focus();}
});
  } catch(e) { console.error(e); }
})();

})();
